<template>
  <div
    class="z-[999999999] fixed w-[320px] top-3 right-5"
    v-if="messages.length > 0"
  >
    <div v-for="(message, i) in messages" :key="i">
      <Notification :message="message" />
    </div>
  </div>
</template>

<script>
import Notification from "./Notification.vue";

export default {
  components: {
    Notification,
  },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style>
</style>